export default {
    import: null,
    importType: null,
    old: null,
    loading: false,
    error: null,
    errorShow: false
}